"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * To add additional or override reducers for collection, add them to reducerHandlers
 *
 * import { emails, phones } from '../actions/collection'
 *
 * export default {
 *	emails: reducer({ name: 'emails', actionTypes: emails.actionTypes }),
 *	// customize phones
 *	phones: reducer({ name: 'phones', actionTypes: phones.actionTypes, reducers: {
 *		'REMOVE_PHONE': removePhone, // replace default remove with your own remove call
 *		'HIDE_PHONE': hidePhone // add new reducer to handle additional action
 *	}})
 *}
 *
 *
 * Don't forget to add to root.reducers
 * 'emails': reducers.collection.emails,
 * 'phones': reducers.collection.phones,
 */
function reducer(_a) {
    var name = _a.name, // collection name
    actionTypes = _a.actionTypes, // collection action types
    _b = _a.reducers, // collection action types
    reducers = _b === void 0 ? {} : _b, // additional handler to override or handle certain action
    _c = _a.noDuplicate // strict collection with no duplicate id
    , // additional handler to override or handle certain action
    noDuplicate = _c === void 0 ? true : _c // strict collection with no duplicate id
    ;
    return function (state, action) {
        if (state === void 0) { state = []; }
        if (reducers.hasOwnProperty(action.type)) {
            // leave it to customized handler
            return reducers[action.type](state, action);
        }
        else {
            switch (action.type) {
                // selected element will have new selected property set to true
                case actionTypes.SELECT: {
                    var elements = state.map(function (element) {
                        if (element.id === action.data) {
                            element.selected = true;
                        }
                        else if (element.selected) { // if object is selected earlier
                            element.selected = false;
                        }
                        return Object.assign({}, element);
                    });
                    return tslib_1.__spreadArrays(elements);
                }
                case actionTypes.ADD: {
                    if (noDuplicate && state.find(function (element) { return element.id === action.data.id; })) {
                        return state;
                    }
                    else {
                        return tslib_1.__spreadArrays(state, [action.data]);
                    }
                }
                case actionTypes.UPDATE: {
                    var hasData_1 = !!action.data;
                    var elements = state.map(function (element) {
                        if (hasData_1 && element.id === action.data.id) {
                            return action.data;
                        }
                        else {
                            return element;
                        }
                    });
                    return tslib_1.__spreadArrays(elements);
                }
                case actionTypes.REMOVE: {
                    var elements = state.filter(function (element) { return element.id !== action.data; });
                    return tslib_1.__spreadArrays(elements);
                }
                default: {
                    // This is for default server initialization with data from bundler
                    return action[name] ? Object.assign({}, state, action[name]) : state;
                }
            }
        }
    };
}
exports.default = reducer;
